import t from '@guestyci/localize/t.macro';

export const getWidgetInitError = () =>
  t('Failed to initialize authentication. Please refresh the page.');

export const getWidgetNotLoadedError = () => t('Widget not loaded');

export const getAuthNotReadyError = () =>
  t('Authentication not ready. Please refresh.');

export const getAuthNotReadyWaitError = () =>
  t('Authentication not ready. Please wait.');

export const getGoogleNotConfiguredError = () =>
  t('Google sign-in is not configured.');

export const getGoogleSignInFailedError = () =>
  t('Google sign-in failed. Please try again.');

export const getMfaCodeSubmitError = () =>
  t('Unable to submit the verification code. Please try again.');

export const getMfaCodeResendError = () =>
  t('Unable to resend the verification code. Please try again.');

export const getMfaCodeInvalidError = () =>
  t('The code you entered is invalid. Please check and try again.');

export const normalizeOktaError = err => {
  const apiError = err?.xhr?.responseJSON;
  if (!apiError) return err;
  return {
    ...err,
    errorCode: apiError.errorCode,
    errorSummary: apiError.errorSummary,
  };
};

export const getTranslatedErrorMessage = error => {
  if (error?.statusCode === 401) {
    return t('The email or password is incorrect. Please try again');
  }

  if (error?.errorCode === 'E0000004') {
    return t('Sorry, we do not recognize those details.');
  }

  if (error?.errorCode === 'E0000068') {
    return getMfaCodeInvalidError();
  }

  if (
    error?.errorCode === 'E0000069' ||
    error?.errorCode === 'error.auth.lockedOut'
  ) {
    return t('Too many failed attempts. Please try again in 10 minutes.');
  }

  return error?.errorSummary || t('Authentication failed');
};
